module.exports = __webpack_public_path__ + "static/media/youcoachlogo_white.aabe56f0.svg";